import * as React from 'react';
import Button, { ButtonProps } from '../Control/Button';
import { StyleSheet, css } from 'aphrodite';
import { Close } from '../../Assets/images/svg';
import { Common } from '../../Assets/styles/common';

interface ModalProps {
    isOpen: boolean;
    size?: number | string;
    onClose?: () => void;
    header?: JSX.Element;
    cancelText?: string | JSX.Element;
    mainActionButton: ButtonProps;
    nonClosingActionButton?: ButtonProps;
    tertiaryActionArea?: JSX.Element;
    closable?: boolean;
}

const footerStyles = () => {
    return {
        display: 'flex',
        background: Common.Color.background,
        borderTop: `solid 1px ${Common.Color.cardBorder}`,
        borderBottomLeftRadius: Common.Borders.radiusLarge,
        borderBottomRightRadius: Common.Borders.radiusLarge,
        padding: `16px 32px`,
        ['& > *:not(:firstChild)']: { marginLeft: '16px', },
        justifyContent: 'flex-end',
    };
};

export class Modal extends React.Component<ModalProps> {
    public onEscape = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode === 27 && this.props.closable) {
            this.props.onClose!();
        }
    }

    public componentDidMount() {
        document.addEventListener('keydown', this.onEscape as any);
    }

    public componentWillUnmount() {
        document.removeEventListener('keydown', this.onEscape as any);
    }

    public render() {
        const { isOpen, header, mainActionButton, nonClosingActionButton, cancelText, onClose, tertiaryActionArea, closable } = this.props;
        const { children, onClick } = mainActionButton;
        let nonClosingButton;
        if (nonClosingActionButton) {
            const { children: childrenNonClosing, onClick: nonClosingButtonClick } = nonClosingActionButton;
            nonClosingButton = <Button className={css(styles.button)} mt={0} width="auto" secondaryButton={true} onClick={nonClosingButtonClick}>{childrenNonClosing}</Button>;
        }
        return (
            <React.Fragment>
                <div
                    className={css(styles.backdrop)}
                    style={{pointerEvents: isOpen ? 'auto' : 'none', display: isOpen ? 'block' : 'none'}}
                    onClick={closable ? onClose : undefined}
                />
                <div
                    className={css(styles.modalWrapper)}
                    style={{display: isOpen ? 'flex' : 'none'}}
                >
                    {closable ?
                    <div
                        className={css(styles.closeIcon)}
                        color={Common.Color.lightGray}
                        onClick={onClose}
                    >
                        <Close/>
                    </div> : null
                    }
                    <div className={css(styles.header)}>
                        <h4 className={css(styles.h4)}>{header}</h4>
                    </div>
                    <div className={css(styles.content)}>{this.props.children}</div>
                    <div style={footerStyles()}>
                        {tertiaryActionArea ? <div className={css(styles.tertiaryArea)}>{tertiaryActionArea}</div> : null}
                        {cancelText && closable ? (
                            <Button className={css(styles.button)} onClick={onClose} mt={0} pl={0} pr={0} width="auto" secondaryButton={true}>
                                {cancelText}
                            </Button>
                        ) : null}
                        {!closable ?
                            nonClosingButton
                            : null
                        }
                        {closable ?
                            <Button className={css(styles.button)} mt={0} pl={0} pr={0} width="auto" onClick={onClick}>{children}</Button>
                            : null
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const styles = StyleSheet.create({
    header: {
        display: 'block',
        borderBottom: `solid 1px ${Common.Color.cardBorder}`,
        padding: `${Common.padding.small} ${Common.padding.default}`,
    },
    content: {
        display: 'block',
        overflowY: 'auto',
        padding: `${Common.padding.tiny} ${Common.padding.default} ${Common.padding.tiny} ${Common.padding.default}`,
    },
    closeIcon: {
        position: 'absolute',
        top: '30px',
        right: '32px',
        cursor: 'pointer',
    },
    tertiaryArea: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
    },
    h4: {
        width: '422px',
        height: '28px',
        fontFamily: 'Lato',
        fontSize: '18px',
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 1.56,
        letterSpacing: 'normal',
        color: '#212b36',
        margin: 0,
        padding: 0
    },
    button: {
        marginLeft: '16px',
    },
    backdrop: {
        position: 'fixed',
        pointerEvents: 'auto',
        top: '0px',
        bottom: '0px',
        left: '0px',
        right: '0px',
        background: 'rgba(0, 0, 0, 0.45)',
        zIndex: 101,
    },
    modalWrapper: {
        position: 'fixed',
        left: '50%',
        maxHeight: '100vh',
        flexDirection: 'column',
        background: '#fff',
        zIndex: 102,
        borderRadius: Common.Borders.radiusLarge,
        top: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '680px',
    }
});



// WEBPACK FOOTER //
// ./src/CommonUI/UI/Modal.tsx